import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventAprobacionMasivaService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onAprobacionMasivaComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventAprobacionMasivaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventAprobacionMasivaService_Factory() { return new EventAprobacionMasivaService(); }, token: EventAprobacionMasivaService, providedIn: "root" });
